import axios from "axios";
import { redirect } from "next/navigation";
import { reduxStore } from "@/lib/redux";

const isServer = typeof window === "undefined";
const apiClient = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API}`
});

apiClient.interceptors.request.use(async (config) => {
  // config.headers["Content-Type"] = `application/json`;

  if (isServer) {
    const { cookies } = await import("next/headers");
    const xAccessToken = cookies().get("@dental-map/xAccessToken")?.value;

    if (xAccessToken) {
      config.headers["Authorization"] = `Bearer ${xAccessToken}`;
    }
  } else {
    const globalState = reduxStore.getState();
    const xAccessToken = globalState?.user.access_token;

    if (xAccessToken) {
      config.headers["Authorization"] = `Bearer ${xAccessToken}`;
    }
  }

  return config;
});

apiClient.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    if (error?.response?.status === 401) {
      if (isServer) {
        redirect("/auth/login");
      } else if (window.location.pathname !== "/auth/login") {
        window.location.replace("/auth/login");
      }
      const requestConfig = error.config;
      return axios(requestConfig);
    } else if (error?.response?.status === 402) {
      if (isServer) {
        redirect("/home");
      } else if (window.location.pathname !== "/home") {
        window.location.replace("/home");
      }
      const requestConfig = error.config;
      return axios(requestConfig);
    }
    return Promise.reject(error);
  }
);
const api = apiClient;
export default api;
